/** Auto-link URLs and bare hgwindustry.com paths inside a plain-text chat message. */
export default function MessageText({ text }) {
  if (!text) return null;
  const rx = /((?:https?:\/\/[^\s]+)|(?:(?:www\.)?hgwindustry\.com\/[^\s.,;)\]]*))/gi;
  const parts = [];
  let last = 0;
  let m;
  while ((m = rx.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    let url = m[0];
    const trail = url.match(/[.,;!?)\]]+$/);
    let trailing = "";
    if (trail) {
      trailing = trail[0];
      url = url.slice(0, -trailing.length);
    }
    const href = url.startsWith("http") ? url : `https://${url}`;
    let finalHref = href;
    try {
      const u = new URL(href);
      if (u.hostname === "hgwindustry.com" || u.hostname === "www.hgwindustry.com") {
        finalHref = u.pathname + u.search + u.hash || "/";
      }
    } catch (_) {}
    parts.push(
      <a
        key={`${m.index}-${url}`}
        href={finalHref}
        className="underline underline-offset-2 hover:no-underline"
        target={finalHref.startsWith("http") ? "_blank" : undefined}
        rel="noreferrer"
      >
        {url}
      </a>
    );
    if (trailing) parts.push(trailing);
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts.length ? parts : text;
}
